import { useTranslation } from 'react-i18next';

/**
 * Página de Erro 500 - Erro interno do servidor
 * Fidelidade visual pixel-perfect com o original Rails
 */
interface Error500PageProps {
  errorMessage?: string;
}

export function Error500Page({ errorMessage }: Error500PageProps) {
  const { t } = useTranslation();
  return (
    <div className="text-center w-full mt-[100px]">
      <div className="text-[68px]">{t('views.errors.oops', 'Ops!')}</div>
      <div className="text-[22px]">{t('views.errors.server_error_title', 'Falha ao processar')}</div>
      <div className="text-[18px] mt-[10px]">
        {errorMessage || t('views.errors.server_error_text', 'Aconteceu um erro que não prevíamos. Desculpe-nos. Já fomos notificados que este problema ocorreu e em breve o solucionaremos.')}
      </div>
    </div>
  );
}
